import React, { useState } from 'react'

const StepOne = ({ form, onChange, onNext }) => {
  const [error, setError] = useState('')

  const handleSubmit = e => {
    e.preventDefault()
    if (!form.firstName || !form.lastName || !form.phone) {
      setError('لطفاً تمام فیلدها را کامل کنید.')
      return
    }
    if (!/^09\d{9}$/.test(form.phone)) {
      setError('لطفاً شماره همراه معتبر (مثال: 09123456789) وارد کنید.')
      return
    }

    setError('')
    onNext()
  }

  return (
    <form onSubmit={handleSubmit} autoComplete='off'>
      {error && <div className='error-message'>{error}</div>}

      <div className='input-group'>
        <label>نام</label>
        <input
          type='text'
          name='firstName'
          value={form.firstName}
          onChange={onChange}
          required
          autoFocus
          placeholder='نام خود را وارد کنید'
        />
      </div>

      <div className='input-group'>
        <label>نام خانوادگی</label>
        <input
          type='text'
          name='lastName'
          value={form.lastName}
          onChange={onChange}
          required
          placeholder='نام خانوادگی خود را وارد کنید'
        />
      </div>

      <div className='input-group'>
        <label>شماره همراه</label>
        <div className='phone-input-container'>
          <input
            type='tel'
            name='phone'
            value={form.phone}
            onChange={onChange}
            required
            pattern='^09\d{9}$'
            placeholder='09xxxxxxxxx'
          />
        </div>
      </div>

      {/* فیلد آیدی تلگرام حذف شد */}

      <div className='form-actions'>
        <button type='submit' className='next-btn'>
          مرحله بعد
        </button>
      </div>
    </form>
  )
}

export default StepOne
